import { Component, inject } from '@angular/core';
import { TelemetryService } from 'app/core/services/telemetry.service';

@Component({
    selector: 'app-unauthorized',
    imports: [],
    templateUrl: './unauthorized.component.html',
    styles: ``
})
export class UnauthorizedComponent {
    private telemetryService = inject(TelemetryService);
    private authFailure = this.telemetryService.getLatestAuthFailure();
    protected readonly referenceNumber = this.authFailure?.referenceNumber;
    protected readonly errorDescription = this.authFailure?.errorDescription;
}
